import { render } from "./NoticeModalDetailModal.vue?vue&type=template&id=264fcd26&scoped=true"
import script from "./NoticeModalDetailModal.vue?vue&type=script&lang=js"
export * from "./NoticeModalDetailModal.vue?vue&type=script&lang=js"

import "./NoticeModalDetailModal.vue?vue&type=style&index=0&id=264fcd26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264fcd26"]])

export default __exports__